import * as api from '~/api';
import { DATE_AND_SPECIALIST } from '~/utils/urlApi';
export const apiRequestSpecialistByHospital = (
  baseUrl,
  info,
  // hospitalId = 2,
) => {
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };

  const formData = new FormData();
  formData.append('user_id', info.user_id);
  formData.append('access_token', info.access_token);
  // formData.append('hospital_id', hospitalId);
  // ?user_id=${info.user_id}&access_token=${info.access_token}&hospital_id=${hospitalId}
  return api.postHttpRequestAsync(
    `${baseUrl}${DATE_AND_SPECIALIST.GET_ALL_SPECIALIST}`,
    formData,
    config,
  );
};
